import { GET } from "../config";

const getDashboardData = (params) => {
  return GET("analytics/dashboard/summary/", { params });
};

const getCashFlow = (params) => {
  return GET("analytics/financial-dashboard/cash-flow/", { params });
};

const getIncomeExpense = (params) => {
  return GET("analytics/financial-dashboard/income-expense/", { params });
};

const getFinancialDashboard = (params) => {
  return GET("analytics/financial-dashboard/", { params });
};

const dashboardEndpoints = {
  getDashboardData,
  getCashFlow,
  getIncomeExpense,
  getFinancialDashboard,
};

export default dashboardEndpoints;
